import TLDR from "/src/components/tldr-section.js";
import SubscribeSectionDownloadable from "/src/components/subscribe-section-downloadable.js";
import * as React from 'react';
export default {
  TLDR,
  SubscribeSectionDownloadable,
  React
};